export default __webpack_public_path__ + "static/media/talkback@3x.7ef238f0.png";